var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-6 border-t-2 border-gray-200 pt-6" }, [
    _c("dl", [
      _c("div", [
        _c("dt", { staticClass: "text-lg leading-7" }, [
          _c(
            "button",
            {
              staticClass:
                "text-left w-full flex justify-between items-start text-gray-400 focus:outline-none focus:text-gray-900",
              on: {
                click: function($event) {
                  _vm.isOpen = !_vm.isOpen
                }
              }
            },
            [
              _c("span", { staticClass: "font-medium text-gray-900" }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ]),
              _c("span", { staticClass: "ml-6 h-7 flex items-center" }, [
                _c(
                  "svg",
                  {
                    staticClass: " h-6 w-6 transform",
                    class: {
                      "-rotate-180": _vm.isOpen,
                      "rotate-0": !_vm.isOpen
                    },
                    attrs: {
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 9l-7 7-7-7"
                      }
                    })
                  ]
                )
              ])
            ]
          )
        ]),
        _c(
          "dd",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "mt-2 pr-12"
          },
          [
            _c("p", { staticClass: "text-base leading-6 text-gray-500" }, [
              _vm._v(" " + _vm._s(_vm.content) + " ")
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }